import styled from 'styled-components';
import { useWindowSize } from 'shared/hooks/useWindowSize';
import { useMousePosition } from 'shared/hooks/useMousePosition';

interface IBrandTabButtonsProps {
  handleClickNext: () => void;
  handleClickPrevious: () => void;
  numOfHeroes: number;
  swiper: any;
  swiperActiveIndex: number;
  isBrandPage?: boolean;
}

export const BrandTabButtons = ({
  handleClickNext,
  handleClickPrevious,
  numOfHeroes,
  swiper,
  swiperActiveIndex,
  isBrandPage = false,
}: IBrandTabButtonsProps) => {
  const { windowSize } = useWindowSize();
  const { x, y } = useMousePosition(100);
  const isOnSpace = y >= 100;
  const isOnLeftSide = x < windowSize?.width / 2 && isOnSpace;
  const isOnRightSide = x >= windowSize?.width / 2 && isOnSpace;

  return (
    <>
      {swiper?.allowSlidePrev && (
        <BrandTabButtons.LeftButton
          $isVisible={swiperActiveIndex > 0 && isOnLeftSide}
          $brandOffset={isBrandPage}
        >
          <BrandTabButtons.Image
            alt="indicator there is a previous view"
            className="swiper-button-prev"
            onClick={handleClickPrevious}
            src="/images/previous_dark.png"
          />
        </BrandTabButtons.LeftButton>
      )}
      {swiper?.allowSlideNext && (
        <BrandTabButtons.RightButton
          $isVisible={swiperActiveIndex < numOfHeroes - 1 && isOnRightSide}
          $brandOffset={isBrandPage}
        >
          <BrandTabButtons.Image
            onClick={handleClickNext}
            alt="indicator there is a next view"
            className="swiper-button-next"
            src="/images/next_dark.png"
          />
        </BrandTabButtons.RightButton>
      )}
    </>
  );
};

BrandTabButtons.IterateButton = styled.button<{ $isVisible: boolean; $brandOffset: boolean }>`
  bottom: 0;
  cursor: default;
  height: 100vh;
  min-width: 25%;
  opacity: 0;
  pointer-events: none;
  position: fixed;
  top: ${({ $brandOffset }) => ($brandOffset ? `50px` : `124px`)};
  user-select: none;
  width: auto;
  z-index: ${({ theme }) => theme.zIndex.arrowButton};

  opacity: ${({ $isVisible }) => ($isVisible ? '1' : '0')};

  @media (max-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    display: none;
  }
`;

BrandTabButtons.RightButton = styled(BrandTabButtons.IterateButton)`
  right: 32px;
`;

BrandTabButtons.LeftButton = styled(BrandTabButtons.IterateButton)`
  left: 32px;
`;

BrandTabButtons.Image = styled.img`
  pointer-events: auto;
  margin: auto;
  max-height: 16px;
  min-height: 16px;
  width: auto;

  @media (max-width: ${({ theme }) => theme.breakpoints.mediumSmall}px) {
    display: none;
  }
`;
